import srraf from "srraf"

const breakpoints = [480, 720, 960, 1024, 1200, 1400]

const widthWatcher = () => {
  const reversedBreakpoints = breakpoints.reverse()

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  let lastSize = viewportWidth

  srraf(({ vw }) => {
    document.dispatchEvent(new CustomEvent("window:resized"))

    if (vw > lastSize) {
      breakpoints.forEach((width) => {
        if (lastSize < width && vw >= width) {
          document.dispatchEvent(new CustomEvent(`window:above-${width}`))
        }
      })
    } else {
      reversedBreakpoints.reverse().forEach((width) => {
        if (lastSize > width && vw < width) {
          document.dispatchEvent(new CustomEvent(`window:below-${width}`))
        }
      })
    }

    if (vw !== lastSize) {
      document.dispatchEvent(new CustomEvent("window:width-changed"))
    }

    lastSize = vw
  })
}

export default widthWatcher
